<template>
	<div class="dashboard_heading">
		<h1>Hello, {{ user.name }}</h1>
		<p>Welcome to your InsureCAREteams dashboard. What can we help you with?</p>
	</div>
</template>

<script>
	import store from '@/store';

	export default {
		name: 'InsureCareTeamsWelcome',
		computed: {
			user: () => store.state.Auth.user,
		},
	};
</script>
